var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mode=Light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70737 4.29289C5.31685 3.90237 4.68368 3.90237 4.29316 4.29289C3.90264 4.68342 3.90264 5.31658 4.29316 5.70711L10.586 11.9999L4.2929 18.2929C3.90237 18.6834 3.90237 19.3165 4.29289 19.7071C4.68341 20.0976 5.31657 20.0976 5.7071 19.7071L12.0002 13.4141L18.2932 19.7071C18.6837 20.0976 19.3168 20.0976 19.7074 19.7071C20.0979 19.3166 20.0979 18.6834 19.7074 18.2929L13.4144 11.9999L19.7072 5.70719C20.0977 5.31667 20.0977 4.68351 19.7072 4.29298C19.3167 3.90245 18.6835 3.90245 18.293 4.29297L12.0002 10.5857L5.70737 4.29289Z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.d07a29e0.svg";
export { ForwardRef as ReactComponent };